module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }